import { render, staticRenderFns } from "./UserUpskilling.vue?vue&type=template&id=95b098f2&"
import script from "./UserUpskilling.vue?vue&type=script&lang=js&"
export * from "./UserUpskilling.vue?vue&type=script&lang=js&"
import style0 from "./UserUpskilling.vue?vue&type=style&index=0&id=95b098f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports